import React, { FC } from "react";
import "./style.scss";

/**
 * A component that renders a CRT scanline effect overlay.
 * Uses CSS to create a retro CRT monitor appearance with horizontal scan lines.
 *
 * @component
 * @example
 * ```tsx
 * <div className="screen">
 *   <content />
 *   <Scanlines />
 * </div>
 * ```
 */
const Scanlines: FC = () => <section className="__scanlines__" />;

export default Scanlines;
